export default function ContentSecond({verticalTabsState}) {
  return (
    <div
      className={`content-2 overflow-hidden max-h-0 transition-opacity duration-[0.2s] ease-linear ${
        verticalTabsState === 2
          ? "max-h-[1000px] opacity-100 z-2"
          : "opacity-0 max-h-0 z-0"
      }`}
    >
      <h1 className="text-[36px] my-[0.67em] leading-[40px] font-mont">
        <strong>
          The Real Customer Centric CRM
        </strong>
      </h1>

      <p className="mb-[25px] text-[16px] leading-[28px]">
        Track leads, close opportunities<br></br>and get accurate forecasts.
      </p>

      <h2 className="text-[30px] leading-[40px] mt-5 mb-[10px] font-mont">
        <strong>Get Accurate Forecasts</strong>
      </h2>

      <p className="my-[10px] text-[16px] leading-[20px]">
        Use actionable data to make better decisions.
      </p>

      <p className="my-[10px] text-[16px] leading-[20px]">
        Get the insights you need to make smarter decisions.
      </p>

      <p className="my-[10px] text-[16px] leading-[20px]">
        Design custom dashboards to get a picture of your business at a glance.
      </p>

      <p className="my-[10px] text-[16px] leading-[20px]">
        Dig deeper with real-time reports and flow charts that anyone can create and share.
      </p>

      <h2 className="text-[30px] leading-[40px] mt-5 mb-[10px] font-mont">
        <strong>Get More Done In Less Time</strong>
      </h2>

      <p className="my-[10px] text-[16px] leading-[20px]">
        Great Tools = Happy People
      </p>

      <p className="my-[10px] text-[16px] leading-[20px]">
        Schedule activities based on your sales scripts: calls, meetings,
        mailing, and quotations. Get all information you need, directly on the
        opportunity: website pages viewed, mail received, etc.
      </p>

      <h2 className="text-[30px] leading-[40px] mt-5 mb-[10px] font-mont">
        <strong>Real-time Overview</strong>
      </h2>

      <p className="my-[10px] text-[16px] leading-[20px]">
        Easily review your performances & next activities.
      </p>

      <p className="my-[10px] text-[16px] leading-[20px]">
        Know exactly how you perform compared to your monthly targets.
        <br></br>
        Organize your work based on your scheduled next actions
      </p>

      <h2 className="text-[30px] leading-[40px] mt-5 mb-[10px] font-mont">
        <strong>Stay Connected To Your Customers</strong>
      </h2>

      <p className="my-[10px] text-[16px] leading-[20px]">
        Real-time messaging to enhance collaboration.
      </p>

      <p className="my-[10px] text-[16px] leading-[20px]">
        Get a quick overview of what's going on in your team. See when a
        colleague logs a call or send a quote. Share ideas and files in
        real-time and catch-up things you missed when you were away.
      </p>
    </div>
  );
}
